module.exports = __webpack_public_path__ + "static/story3-index-thumbnails-1920x1080-30b85b0bfa0fb209916d9df7fb57c434.jpg";